import {
  ActivateAllDomainsProductMutation,
  ActivateAllDomainsProductMutationVariables,
} from 'gql/graphql'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { useDomainsProductSnackbar } from '../useDomainsProductSnackbar'
import { ACTIVATE_ALL_DOMAINS_PRODUCT } from './mutation'

import type { UseActivateAllDomainsProduct } from './types'

export const useActivateAllDomainsProduct = (): UseActivateAllDomainsProduct => {
  const { snackbar } = useDomainsProductSnackbar()

  const { isPending: loading, mutateAsync } = useMutation<
    ActivateAllDomainsProductMutationVariables,
    ActivateAllDomainsProductMutation
  >({
    mutation: ACTIVATE_ALL_DOMAINS_PRODUCT,
    onCompleted: async (
      data: ActivateAllDomainsProductMutation,
      variables: ActivateAllDomainsProductMutationVariables,
    ) => {
      const { activateAllDomainsProduct } = data
      const product = variables.input.productType

      if (activateAllDomainsProduct?.errors) {
        const { errors } = activateAllDomainsProduct
        if (errors && errors.length > 0) {
          snackbar({ enabled: true, product, variant: 'error' })
        }
      } else {
        snackbar({ enabled: true, product, variant: 'success' })
      }
    },
    queriesToInvalidate: ['getDomainsForTable'],
  })

  const activateAllDomainsProduct: UseActivateAllDomainsProduct['activateAllDomainsProduct'] =
    product => {
      void mutateAsync({
        input: {
          productType: product,
        },
      })
    }

  return { activateAllDomainsProduct, loading }
}
